import { VehicleTile } from "../components/VehicleTile"
import { Link, useLoaderData, useNavigate } from "react-router-dom"
import { TextField } from "../components/TextField";
import { useEffect, useState } from "react";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";





function renderVehicleList(vehicles,searchFilter){
	return (
		<div className="customer-list">
			{
			vehicles.map(vehicle => (
				<VehicleTile key={vehicle.license_plate} vehicle={vehicle} />
			))}
		</div>
	);
}



export function Vehicles(){
	const {vehicles} = useLoaderData();
	const [searchFilter,setSearchFilter] = useState("");
	const navigate = useNavigate();
	let filteredVehicles = vehicles.vehicles.filter(vehicle =>vehicle.customer_name.toLowerCase().includes(searchFilter.toLowerCase())
			|| vehicle.license_plate.toLowerCase().includes(searchFilter.toLowerCase())
			|| vehicle.vehicle_name.toLowerCase().includes(searchFilter.toLowerCase())
		);

		useEffect(()=>{
			mixpanel.identify(getUserId());
		},[]);


	return (
		<main id="Dashboard">
		<h1>Vehicles ({filteredVehicles.length})</h1>

		<div className="row" id="page-actions">

			<TextField
				hint="Customer Name or License Plate"
				value={searchFilter}
				onChange={(value)=>{setSearchFilter(value.target.value);}}
			/>

		</div>


		<table>
			<thead>
				<tr>
					<th>Make & Model</th>
					<th>Customer Name</th>
					<th>Insurance</th>
					<th>Roadworthy Expiry</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				{filteredVehicles.map(vehicle=>
				<tr>
					<td className="clickable" onClick={()=>navigate(`/dashboard/vehicles/${vehicle.license_plate}/services`)}>{vehicle.vehicle_name} (<small>{vehicle.license_plate}</small>)</td>
					<td className="clickable" onClick={()=>navigate(`/dashboard/members/u/${vehicle.customer_id}/vehicles`)}>{vehicle.customer_name}</td>
					<td>{vehicle.insurance_provider ?<> {vehicle.insurance_provider} <small>{`(${vehicle.insurance_expiry})`}</small> </>: <small>{"Not provided"}</small>}</td>
					<td>{vehicle.roadworthy_expiry ? vehicle.roadworthy_expiry : <small>{"Not provided"}</small>}</td>
					<td>
						<Link to={`/dashboard/services/add_ticket`} state={{customer_id: vehicle.customer_id, vehicle_id : vehicle.vehicle_id}} className="actions">Add Service</Link>
						{/* <Link to={`/dashboard/vehicles/${vehicle.license_plate}/add_service`} className="actions">Add Service</Link> */}
					</td>
				</tr>)}
			</tbody>
		</table>

		{/* {renderVehicleList(filteredVehicles,searchFilter)} */}


		</main>
	)
}